const data = {
    "Main": "Главная",
    "Transportation organization": "Организация перевозок",
    "Dispatching": "Диспетчеризация",
    "Sales": "Продажи",
    "Administration": "Администрирование",
    "Logout": "Выход",
    "Search": "Поиск",

    "Trips": "Рейсы",
    "Reporting": "Отчетность",

    "Logs": "Логи",
    "Cashier action": "Действие кассира",

    "Pricing": "Ценообразование",
    "Tariffs": "Тарифы",
    "Privileges": "Льготы",
    "Baggage": "Багаж",
    "Attach baggage": "Прикрепить багаж",
    "Passenger ID": "ID пассажира",
    "Baggage count": "Количество багажа",
    "Baggage id": "ID багажа",
    "Baggage attached": "Багаж прикреплен",
    "Previously attached baggage": "Ранее прикрепленный багаж",
    "Newly attached baggage": "Новый прикрепленный багаж",
    "Print all": "Печать всех",
    "Created at": "Дата создания",
    "Bus seat": "Место",
    "Attach": "Прикрепить",
    "Services": "Услуги",

    "Profile": "Профиль",
    "My profile": "Мой профиль",

    "Sales reporting": "Отчетность по продажам",
    "Online sales reporting": "Отчетность по онлайн продажам",
    "Dispatch reporting": "Отчетность диспетчеризации",
    "Transporter reports": "Отчеты по перевозчикам",
    "Reports for Min. Trans.": "Отчеты для Мин.Транс.",
    "Reports for Validator.": "Отчет валидаторов",
    "Reversals": "Отчет о возврате",

    "Cashier's workplace": "Рабочее место кассира",
    "Ticket selling": "Продажа билетов",
    "Armor redemption": "Выкуп брони",
    "Ticket return": "Возврат билета",
    "Restore ticket": "Восстановить билета",

    "Schedule": "Расписание",
    "Areas": "Области",
    "Bus terminals": "Автовокзалы",
    "Routes": "Маршруты",
    "Schedule trips": "Рейсы расписания",

    "Settings": "Настройки",
    "Options": "Параметры",
    "Returns": "Возвраты",
    "Booking": "Бронирование",
    "Booking List": "Список броны",
    "Work with transporter": "Работа с перевозчиками",

    "Transporter": "Перевозчик",
    "Buses": "Автобусы",
    "Bus types": "Типы автобусов",

    "Employees": "Сотрудники",
    "Roles": "Роли",
    "API Clients": "Клиенты API",

    "Creation - Editing": "Создание - редактирование",
    "Baggage (Editing)": "Багаж (Редактирование)",
    "Save and close": "Записать и закрыть",
    "Fixed amount": "Фиксированная сумма",
    "Interest Amount": "Процентная сумма",
    "Amount depending on km": "Сумма в звисимости от км",
    "Title": "Название",
    "Weight to (kg)": "Вес до (кг)",
    "Step (km)": "Шаг (км)",
    "Additional settings": "Доп.настройки",
    "From (km)": "От (км)",
    "To (km)": "До (км)",
    "Price for this step": "Цена за данный шаг",
    "Price": "Цена",
    "Percent": "Процент",
    "Action": "Действия",
    "Reservation fee": "Доплата за бронирование",
    "bag for a ticket": "сум за билет",
    "It is allowed to book more than 1 place for a cashier": "Разрешено бронировать более 1 места для кассира",
    "Not": "Нет",
    "Passenger personal data required": "Персональные данные пассажира требуются",
    "Required": "Требуются",
    "Not required": "Не требуются",
    "Places are again available for sale for": "Места снова становятся доступны для продажи за",
    "minutes before departure": "минут до отбытия",
    "Booking is removed through": "Бронь снимается через",
    "minutes": "минут",
    "Yes": "Да",
    "No": "Нет",
    "Editing": "Редактирование",
    "Creature": "Создание",
    "buses": "автобусов",
    "This field is required": "Это поле обязательно к заполнению",
    "Model": "Модель",
    "Driver": "Водитель",
    "Generate to finish": "Генерировать до конца",
    "Number bus": "Номер автобуса",
    "Create": "Создать",
    "Transporters": "Перевозчики",
    "Number": "Номер",
    "Status": "Статус",
    "Active": "Активный",
    "Inactive": "Неактивный",
    "Loading": "Загружается",
    "Choose a transporter": "Выберите перевозчик",
    "Choose a bus model": "Выберите модель автобуса",
    "Choose a driver": "Выберите водитель",

    "Creation": "Создание",
    "Types of buses (creation - editing)": "Типы автобусов (создание - редактирование)",
    "How many floors": "Сколько этажей",
    "First floor": "Первый этаж",
    "Second floor": "Второй этаж",
    "Swap From": "Поменять с",
    "Created place": "Созданное место",
    "Created a place for the disabled": "Созданное место для инвалидов",
    "Created place for passengers with children": "Созданное место для пассажиров с детьми",
    "Floors": "Этажность",
    "Create a new type": "Создать новый тип",
    "Users": "Пользователи",
    "Name": "Имя",
    "Phone number": "Номер телефона",
    "Type": "Тип",
    "Status user": "Статус пользователья",
    "Confirm the password": "Потвердите пароль",
    "Select user type": "Выберите тип пользователья",
    "Refresh": "Обновить",
    "Old Password": "Старый пароль",
    "Password": "Пароль",
    "Employee's role": "Роль сотрудника",
    "Add roles": "Добавить роли",
    "New Password": "Новый пароль",
    "Confirmed Password": "Потвердите пароль",
    "Your password has been successfully updated": "Ваш пароль успешно обновлен",
    "Role users": "Роли пользователей",
    "Number of permissions": "Кол-во разрешений",
    "Number of users": "Кол-во пользователей",
    "User Roles (Creation)": "Роли пользователей (создание)",
    "Please select at least one permission": "Пожалуйста, выберите хотя бы одно разрешение",
    "additional trips": "доп. рейсы",
    "Actualize": "Актуализировать",
    "Send trips": "Отправить рейс",
    "Cancel trips": "Отменить рейс",
    "Change trips": "Изменить рейс",
    "Has arrived": "Прибыл",
    "Statement": "Ведомость",
    "List": "Список",
    "Passenger": "Пассажир",
    "Passengers": "Пассажиры",
    "Export to Excel": "Экспорт в Excel",
    "Select": "Выберите",
    "Trip date": "Дата рейсов",
    "Point of departure": "Пункт отправления",
    "Select stations": "Выберите станции",
    "date": "Дата",
    "Capacity": "Вместимость",
    "Number of occupied places": "Кол-во занятых мест",
    "Platform": "Перрон",
    "Amount": "Сумма",
    "Total amount": "Итого сумма",
    "trip": "рейс",
    "To send": "Отправить",
    "Bus number": "Номер автобуса",
    "Bus brand": "Марка автобуса",
    "Cancel": "Отменить",
    "Place": "Место",
    "Cost": "Стоимость",
    "You cannot disable this trip because it has active passengers.": "Вы не можете отключить эту поездку, потому что у нее есть активные пассажиры.",
    "STATEMENT": "ВЕДОМОСТЬ",
    "LIST": "СПИСОК",
    "Passengers transported in international road transport": "Пассажиров провозимых в международном автомобильном сообщении",
    "attached to the ticket list": "прилагаемый к билетной ведомости",
    "Date and time of departure": "Дата и время отправления",
    "Bus model": "Модель автобуса",
    "Trip": "Рейс",
    "Issued by": "Выдано",
    "Departure": "Отправление",
    "Number of citizenship": "Количество по гражданству",
    "FULL NAME": "Ф.И.О",
    "Places": "Места",
    "Year of birth": "Год рождения",
    "Passport Series and No.": "Паспорт серия и №",
    "Citizenship": "Гражданство",
    "From where": "От куда",
    "Until where": "До куда",
    "Ticket price": "Цена билета",
    "Tickets": "Билеты",
    "Total amount": "Итоговая сумма",
    "Total amount of baggage ticket": "Итоговая сумма билета",
    "Ticket return info": "Информация о возврате билета",

    "Loading data": "Идет загрузка данных",
    "Route": "Маршрут",
    "Departure time": "Время отправления",
    "Price entry": "Ввод цен",
    "Name ATP": "Название АТП",
    "INN": "ИНН",
    "VAT": "НДС",
    "Class code": "ИКПУ",
    "Package code": "Код упаковки",
    "Bank": "Банк",
    "MFO": "МФО",
    "Checking account": "Рассчетный счет",
    "Percentage per passenger": "Процент за пассажира",
    "Percentage per baggage": "Процент за багаж",
    "Price / km": "Цена / км",
    "Find": "Найти",
    "Locality": "Населенный пункт",
    "Adress": "Адрес",
    "Operation mode": "Режим работы",
    "Coordinates": "Координаты",
    "Place of bus station (optional)": "Место автовокзалы (необязательно)",
    "Also known as": "Также известна как",
    "day": "день",
    "Pre-sale fee": "Сбор за предпродажу",
    "sum": "сум",
    "Presale - for sale for more than": "Предпродажа - продажа более чем за",
    "o'clock": "часов",
    "Reserved seats": "Зарезервированные места",
    "Seats": "Месты",
    "Reserved minutes": "Становятся доступны за",
    "become available for": "становятся доступны за",
    "minutes before sending": "минут до отправки",
    "Customize information board color scheme": "Настройка цветовой схемы информационного табло",
    "Background 1": "Задний фон 1",
    "Text color 1": "Цвет текста 1",
    "Background 2": "Задний фон 2",
    "Text color 2": "Цвет текста 2",
    "Show report": "Показать в отчеты",
    "Schedule Flights (Creation)": "Рейсы расписания (создание)",
    "Choose a route": "Выберите маршрут",
    "Trip number": "Номер рейса",
    "Arrival": "Прибытие",
    "On the way": "В пути",
    "Each": "Каждый",
    "Mon": "Пн",
    "Tu": "Вт",
    "We": "Ср",
    "Th": "Чт",
    "Fr": "Пт",
    "Sa": "Сб",
    "Su": "Вс",
    "Various": "Разные",
    "Even": "Четные",
    "Odd": "Нечетные",
    "For example 1-5, 9, 13": "Например 1-5, 9, 13",
    "Days": "Дни",
    "Beginning with": "Начиная с",
    "Ends at": "Закончено в",
    "Choose a bus": "Выберите автобус",
    "Automatic update": "Автоматическая актуализация",
    "International flight": "Международный рейс",
    "Parking": "Стоянка",
    "Send": "Отпр.",
    "Comment": "Комментарий",
    "Choose a rate": 'Выберите тариф',
    "Flights schedule": "Рейсы расписание",
    "Deactivate": "Деактивировать",
    "Destination": "Пункт назначения",
    "Regularity": "Регулярность",
    "Period": "Период",
    "Turned off": "Выключено",
    "Schedule Flights (Change)": "Рейсы расписания (Изменить)",
    "Change": "Изменить",
    "Clear trail flights and generate new ones": "Очистить след. рейсы и сгенерировать новые",
    "Filter": "Фильтр",
    "- day": "-й день",
    "Route number": "Номер маршрута",
    "Add station": "Добавить станцию",
    "Select a station to add": "Выберите станцию для добавления",
    "Choose": "Выбрать",
    "Km": "Км",
    "Tit.": "Назв.",
    "Fault return": "Возврат по вине",
    "Fine": "Штраф",
    "ATP": "АТП",
    "Passenger after flight departure": "Пассажира после ухода рейса",
    "The return of the fault of the passenger to the departure of the flight": "Возврат по вине пассажира до ухода рейса",
    "Creating benefits": "Создание льгот",
    "Route Name": "Наименование маршрута",
    "Write down": "Записать",
    "Add": "Добавить",
    "Bus terminal": "Автовокзал",
    "Login": "Логин",
    "Enter": "Вход",
    "Location": "Местонахождение",
    "Geography": "География",
    "Prochee": "Другое",
    "Cashiers": "Кассиры",
    "Payment System": "Система оплаты",
    "Full name": "Имя фамилия",
    "Passport number": "Номер паспорта",
    "Number place": "Номер места",
    "Trips (creation)": "Рейсы (изменение)",
    "Bus": "Автобус",
    "Region": "Область",
    "Stations": "Станции",
    "Privilege": "Привилегии",
    "Return service": "Возврат услуги",
    "Bus type": "Тип автобуса",
    'Country': 'Страна',
    'Conductor': 'Кондуктор',
    'Reports': 'Отчеты',
    "You are about to delete the record! \nAre you sure?": 'Вы собираетесь удалить запись! \nВы уверены?',
    "Registration": "Регистрация",
    "Tariff": "Тариф",
    "Fine (percentage)": "Штраф(в процентах)",
    "No. ticket": "№ билета",
    "Role has been saved successfully": "Роль была успешно сохранена",
    "Select service type": "Выберите тип услуги",
    "Choose a baggage type": "Выберите тип багажа",
    "Name trip": "Название рейса",
    "Choose region": "Выберите область",
    "Place of residence": "Адрес прописки",
    "Save": "Сохранить",
    "Do you really want to delete this bus station?": "Вы действительно хотите удалить этот автовокзал?",
    "Settings saved!": "Настройки сохранено!",
    "Depth of sales": "Глубина продаж",
    "Presale": "Предпродажа",
    "Place quotas": "Квоты мест",
    //"Bus station services": "Услуги автовокзала",
    "Bus station services": "Сервисные услуги",
    "Required ": "Обязательная",
    "Show in reports": "Пок. в отчеты",
    "Bus station taxes": "Сбор автовокзала",
    "Bus station collection": "Услуги автовокзала",
    "All passengers moved to a new journey.": "Все пассажиры переехали в новое путешествие",
    "HOT !!! Do you really want to delete all trips that start tomorrow and generate new ones?": "ОСТАРОЖНА!!! Вы действительно хотите удалить все поездки, которые начинаются с завтрашнего дня, и генерировать новые? ",
    'Successfully!!!': 'Успешно!!!',
    'Saved!': 'Сохранено!',
    'min': 'мин',
    'h': 'ч',
    'Basic': 'Основное',
    'Do you really want to delete flight schedules?': 'Вы действительно хотите удалить рейс расписания?',
    "You are about to delete the record \nAre you sure?": "Вы собираетесь удалить запись!\n" +
        "Уверены ли вы?",
    "Surname": "Фамилия",
    "Middle name": "Отчество",
    "Do you really want to change the status?": "Вы действительно хотите изменить статус ?",
    "Changed status": "Изменено статус",
    "Failed to change": "Не удалось изменить",
    "Do you really want to delete?": "Вы действительно хотите удалить?",
    "Departure date": "Дата отправления",
    "Number of passengers": "Количество пассажиров",
    "Generate month report": "Сформировать мес отчет",
    "Generate daily report": "Сформировать суточный отчет",
    "Filter by date from": "Фильтр по дате с",
    "by": "по",
    "To form": "Сформировать",
    "Car number": "Номер авто",
    "Count beat": "Кол. бил",
    "Plan": "План",
    "Fact": "Факт",
    "Pass": "Пас",
    "Bag": "Баг",
    "Full name of the driver": "Ф.И.О водителя",
    "Cash": "Нал",
    "Term": "Терм",
    "Print out": "Распечатать",
    "Total": "Итого",
    "Last day": "За последний день",
    "since the beginning of the week": "с начало недели",
    "from the beginning of the month": "с начало месяца",
    "from the beginning of the year": "с начало года",
    "trips": "рейсы",
    "passenger": "пассажир",
    "all places": "всего мест",
    "Name of the Cashier": "ФИО Кассира",
    "Sold tickets": "Продано билетов",
    "Including": "В том числе",
    "Returned tickets": "Возвращено билетов",
    "Sold tickets with no refund": "Продано билетов с вычетом возврата",
    "Number of booking.\n places": "Количество \n брон. \n мест",
    "count": "кол-во",
    "amount": "сумма",
    "Sold Services": "Продано услуг",
    "baggage amount": "багаж сумма",
    "Cashier": "Кассир",
    "All passengers": "Все пассажиры",
    "Village of passengers": "Село пассажиров",
    "No passengers": "Не село пассажиров",
    "Booked seats": "Забронированно мест",
    "Canceled tickets": "Отменено билетов",
    "others": "другие",
    "Selected passengers": "Выбранный пассажиры",
    "Selected Village of passengers": "Выбранный Село пассажиров",
    "Selected No passengers village": "Выбранный Не село пассажиров",
    "Selected Canceled Tickets": "Выбранный Отменено билетов",
    "Selected Returned Tickets": "Выбранный Возвращено билетов",
    "Selected others": "Выбранный Отменено билетовВыбранный другие",
    "Amount of selected passengers": "Сумма выбранный пассажиров",
    "No reports": "Нет отчеты",
    "Everything": "Все",
    "Village": "Село",
    "Not village": "Не село",
    "Booked": "Забронированно",
    "Canceled": "Отменено",
    "Cancelled": "Отмененный",
    "Returned": "Возвращено",
    "other": "другие",
    "Armored": "Бронирован",
    "Did not come": "Не приехал",
    "Had arrived": "Приехал",
    "Canceled for non-payment": "Отменил за неуплату",
    "Validators report": "Отчет валидаторов",
    "Name of Validator": "ФИО Валидатора",
    "Trip time": "Время рейса",
    "minimum length is 3": "минимальное длина равно 3",
    "maximum length is 150": "максимальное длина равно 150",
    "can only be used": "можно использовать только",
    "required field": "поле объязательное",
    "cyrillic letters": "кирилица буквы",
    "latin letters": "латинские буквы",
    "Do you really want to delete this flight?": "Вы действительно хотите удалить этот рейс?",
    "Passenger removed!": "Пассажир удалено!",
    "Trip has been created successfully": "Рейс был успешно создана",
    "Arrived": "Прибывший",
    "You are about to delete the record!\nAre you sure?": "Вы собираетесь удалить запись!\nУверены ли вы?",
    "This stop has already been added to the route.": "Данная остановка уже добавлена в маршрут",
    "Count users": "Кол-во пользователей",
    "For today": "На сегодня",
    "Back": "Назад",

    "For a passenger ticket": "На пассажирский билет",
    "For trip": "На рейс",
    "Baggage selling": "Багаж",
    'Trip id': "Рейс #",
    'Departing': "Станция отправления",
    'Arriving': "Станция назначения",
    'Passenger name': "Клиент",
    'Sold time': "Время покупки",

    "Select a trip for baggage": "Выберите рейс для перевозки багажа",
    "Pre-tickets sold": "Продано билетов предв",
    "Service": "Услуга",
    "sum return": "сум. возвр",
    "income": "доход",
    "cash": "нал",
    "term": "терм",
    "total": "итого",
    "Selected Reserved Seats": "Выбранный Забронировано мест",
    "Selected  others": "Выбранный другие",
    "Phone": "Телефон",
    "Sold in": "Продано в",
    "Updated in": "Обновлено в",
    'Free baggage allowance international': 'Норма беспл. провоза багажа (международная) (кг)',
    'Free baggage allowance local': 'Норма беспл. провоза багажа (местная) (кг)',
    'Max baggage allowance international': 'Максимальная норма провоза багажа (международная) (кг)',
    'Max baggage allowance local': 'Максимальная норма провоза багажа (местная) (кг)',
    'Free baggage allowance': 'Норма беспл. провоза багажа (кг)',
    'Max baggage allowance': 'Максимальная норма провоза багажа (кг)',
    'Paid': 'Оплачено',
    'Baggage id': 'Багаж #',
    'Baggage weight': 'Вес',
    'Tariff defined baggage price': 'Стоимость багажа по тарифу (кг)',
    'Sender name': 'Имя отправителя',
    'Sender phone': 'Телефон отправителя',
    'Receiver name': 'Имя получателя',
    'Receiver phone': 'Телефон получателя',

    // Baggage return page
    'Baggage return': 'Возврат багажного билета',
    'Search by baggage ticket id': 'Поиск по номеру багажного билета',
    'Search by passenger ticket id': 'Поиск по номеру пассажирского билета',

    // Baggage reports page
    'By Trips': 'По рейсам',
    'By Transporters': 'По перевозчикам',
    'Trip departure time': 'Дата отправления рейса',
    'from date': 'с',
    'to date': 'по',
    'Baggage amount': 'Сумма багажного билета',
    'Tickets count': 'Кол. билетов',
    "Selling (without returned tickets)": "Продажа (без возвратов)",
    "Baggage return penalties": "Штраф",

    'Search geo zone': 'Поиск геозон',
    'type to search geo zone..': 'наберите для поиска геозоны',
    'Pay': 'Оплатить',
    'Next': '',
	'Station name': "Название станции",
    "Total tickets sold today": "Всего проданные билеты сегодня",
    "Ticket Recovery":"Восстановление билетов",
    "Empty seats":"Своб. мест",
    "No trips":"Поездок нет",
    "Check ticket":"Проверить билет",
    "Number of ticket":"Номер билета",
    "Search by last name":"Поиск по фамилии",
    "Ticket Details":"Данные билета",
    "Additional fields":"Дополнительные поля",
    "Search flights":"Поиск рейсов",
    "Baggage weight in kg":"Вес багажа в кг",
    "Calculate the cost":"Рассчитать стоимость",
    "Passport":"Паспорт",
    "With baby":"С ребенком",
    "No reserved places found with this reservation! Check the correct order number":"Не найдено ни одного забронированного места с этим заказом! Проверьте правильность номер ордера",
    "Cashier's Logs":"Логи кассира",
    "Cashier Actions":"Действия кассира",
    "Description":"Описание",
    "Action Details":"Подробная информация о действии",
    "No date":"Нет дата",
    "Purchase":"Покупка",
    "Book now":"Забронировать",
    "Flight will be closed through":"Рейс будет закрыт через",
    "Ticket sales time for this trip is over":"Время продажи билетов на эту поездку закончено",
    "Flight info":"Рейс инфо",
    "Free":"Свободно",
    "Reserved":"Зарезервировано",
    "Sold":"Продано",
    "Sold (male)":"Продано(муж)",
    "Sold (female)":"Продано(жен)",
    "Storey": "Этажность",

    "Code": "Код",

    "Gender": "Пол",
    "Male": "Мужской",
    "Female": "Женский",
    "Gender is required": "Необходимо выбрать пол",
    "Information found": "Информация найдена",
    "Information not found": "Информация не найдена",
    "Internal server error": "Внутренняя ошибка сервера",
    "Full name": "Ф.И.О.",
    "Application ID": "ID заявки",
    "Application date": "Дата заявки",
    "Privilege category": "Категория",
    "Validity period": "Срок действия",
    "Privilege check": "Проверка льготы",
    "Check": "Проверить",
    "Checking": "Проверка",
    "All privilege checks": "Проверка всех льгот",
    "Date of birth": "Дата рождения",
    "Checking all privileges. Please wait...": "Проверяются все льготы. Пожалуйста, подождите...",
    "Total": "Всего",
    "Found": "Найдено",
    "Errors": "Ошибки",
    "Debug response": "Ответ для отладки",
    "PINFL must contain 14 digits": "ПИНФЛ должен состоять из 14 цифр",
    "PINFL is required for a privilege ticket": "Для льготного билета необходимо указать ПИНФЛ",
    "A companion requires exactly one primary privileged passenger in the order": "Для сопровождающего в заказе должен быть ровно один основной льготный пассажир",
    "Only one companion is allowed for a primary privileged passenger": "Для одного основного льготного пассажира разрешён только один сопровождающий",
    "Enter date of birth in YYYY-MM-DD format": "Введите дату рождения в формате ГГГГ-ММ-ДД",
    "Privilege check could not be completed": "Не удалось выполнить проверку льгот",
    "Not found": "Не найдено",
    "Response received": "Ответ получен",
    "Records": "Записи",
    "Partial": "Частично",
    "Error": "Ошибка",
    "Chernobyl radiation illness": "Лучевая болезнь вследствие аварии на Чернобыльской АЭС",
    "Nuclear radiation veteran": "Ветеран ядерного облучения",
    "Elderly disabled needing care": "Пожилые и лица с инвалидностью, нуждающиеся в уходе",
    "Accompanying person": "Сопровождающее лицо",
    "Student": "Студент",
    "Disabled youth vocational training": "Профессиональное обучение молодых людей с инвалидностью",
    "Social registry youth competition": "Конкурс молодежи из социального реестра",

    "Close": "Закрыть",
    "Reserved seats become available in": "Забронированные места освободятся через",
    "Passport data is required for international trips": "На международных рейсах необходимо заполнить паспортные данные",
    "Maximum one seat": "Максимум одно место",
    "Passenger personal data": "Персональные данные пассажира",
    "Regular": "Обычный",
    "Passenger type": "Тип пассажира",
    "Passport details must be filled in and unique": "Паспортные данные должны быть заполнены и не должны повторяться",
    "Enter a comment": "Введите комментарий",
    "With a child": "С ребенком",
    "Without a child": "Без ребенка",
    "Payment": "Оплата",
    "Amount to pay": "Сумма к оплате",
    "Received": "Принято",
    "Change due": "Сдача",
    "Payment type": "Тип оплаты",
    "By card": "Пластиковой картой",
    "Pay": "Оплатить",
    "Pay with PIN pad": "Оплатить через PIN-пад",
    "Personal data": "Персональные данные",
    "All fields must be filled in using Latin letters": "Все поля заполняются латинскими буквами",
    "Passport series": "Серия паспорта",
    "Select a country": "Выберите страну",
    "Child's personal data": "Персональные данные ребенка",
    "Child's passport series": "Серия паспорта ребенка",
    "Consent of the other parent": "Согласие второго родителя",
    "Seat booking": "Бронирование мест",
    "The seats you selected have already been booked by other passengers": "Выбранные вами места уже забронированы другими пассажирами",
    "Seat number": "Номер места",
    "You have successfully booked a seat": "Вы успешно забронировали место",
    "Your ID": "Ваш ID",
    "This seat is being booked by another user": "Это место бронируется другим пользователем",
    "User": "Пользователь",
    "User role": "Роль пользователя",
    "Booking type": "Тип бронирования",
    "Domestic": "Внутренний",
    "International": "Международный",
    "Success": "Успешно",
    "Operation completed successfully! The customer paid": "Операция завершена успешно! Клиент оплатил:",
    "An unexpected error occurred.": "Произошла непредвиденная ошибка.",
    "Data was not saved!": "Данные не сохранены!",
    "Error receiving data from the server!": "Ошибка при получении данных с сервера!",
    "Unable to get DeviceId!": "Не удалось получить DeviceId!",
    "Z report opened successfully!": "Z-отчет успешно открыт!",
    "Error opening Z report!": "Ошибка при открытии Z-отчета!",
    "Unable to save the receipt on the server!": "Не удалось сохранить чек на сервере!",
    "Error paying the receipt!": "Ошибка при оплате чека!",
    "Only one seat can be selected!": "Можно выбрать только одно место!",
    "Passenger number": "Номер пассажира",
    "Full name is required": "Необходимо заполнить Ф.И.О.",
    "All passenger data is required for international trips": "На международных рейсах требуются все данные пассажира",
    "All passenger and child data is required for international trips": "На международных рейсах требуются все данные пассажира и ребенка",
    "Full name must contain only Latin letters": "Ф.И.О. должно содержать только латинские буквы",
    "Passport details are invalid": "Паспортные данные указаны неверно",
    "Passport details are required": "Введите паспортные данные",
    "Child's full name must contain only Latin letters": "Ф.И.О. ребенка должно содержать только латинские буквы",
    "International ticket": "Билет на международный рейс",
    "Domestic ticket": "Билет на внутренний рейс",
    "Bus station service": "Услуга автовокзала",
    "Conductor": "Кондуктор",
    "Privilege found": "Льгота найдена",
    "No privilege information found": "Информация о льготе не найдена",
    "Last privilege ticket": "Последний льготный билет",
    "No privilege ticket history found": "История льготных билетов отсутствует",
    "Ticket number": "Номер билета",
    "Ticket date": "Дата билета",
    "Route": "Маршрут",
    "Ticket type": "Тип билета",
    "Ticket cost": "Стоимость билета",
    "Paid amount": "Оплаченная сумма",
    "Privilege code": "Код льготы",
    "Discount percent": "Процент скидки",
    "Trips per year": "Поездок в год",
    "Discount note": "Примечание по льготе",
    "Privilege used": "Льгота использована",
    "Privilege already used": "Эта льгота уже использована",
    "Transport type": "Тип транспорта",
    "Ticket issue date": "Дата выдачи билета",
    "Route type": "Тип маршрута",
    "Ticket series and number": "Серия и номер билета",
    "Full fare amount": "Полная стоимость проезда",
    "Subsidy amount": "Сумма субсидии",
    "Disability group": "Группа инвалидности",
    "Disability reason": "Основание инвалидности",
    "Registration date": "Дата регистрации",
    "Valid from": "Действует с",
    "Valid until": "Срок действия",
    "Document number": "Номер документа",
    "Certificate number": "Номер удостоверения",
    "Organization": "Организация",
    "Course": "Курс",
    "Record": "Запись",
    "Privilege service unavailable": "Сервис проверки временно недоступен. Повторите попытку позже",
    "No privilege checks enabled": "Сейчас не включена ни одна проверка льгот",
    "Privilege check incomplete": "Проверка выполнена частично. Льгота пока не подтверждена",
    "Vocational training status unconfirmed": "Этот ответ не подтверждает обучение по профессиональной программе",
    "No additional details available": "Дополнительных данных нет",
    "Education type": "Тип образования",
    "Education form": "Форма обучения",
    "Education status": "Статус обучения",
    "Speciality": "Специальность",
    "Start year": "Год начала",
    "Survey ID": "Номер анкеты",
    "Poverty level": "Социальная категория",
    "Registry status": "Статус реестра",
    "Chernobyl radiation illness": "Лица, пострадавшие от лучевой болезни вследствие аварии на Чернобыльской АЭС",
    "Nuclear radiation veteran": "Пенсионеры с инвалидностью, проходившие службу на ядерных полигонах и объектах",
    "Elderly disabled needing care": "Одинокие пожилые люди и лица с инвалидностью, нуждающиеся в уходе",
    "Accompanying person": "Сопровождающее лицо одиноких пожилых людей и лиц с инвалидностью",
    "Student": "Студенты",
    "Disabled youth vocational training": "Профессиональное обучение молодежи с инвалидностью",
    "Social registry youth competition": "Члены семей из социального реестра в возрасте 14–30 лет",
    "Social protection registry": "Реестр социальной защиты",
    "World War II participants": "Участники Второй мировой войны"
};

export default data;
